// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.zopim {
   display: none;
  }

body{
   overflow-y: auto !important;
   background-color: rgb(7, 90, 95);
}
  `, "",{"version":3,"sources":["webpack://./src/app/routes/DashboardTV/Styless.css"],"names":[],"mappings":"AAAA;GACG,aAAa;EACd;;AAEF;GACG,2BAA2B;GAC3B,gCAAgC;AACnC","sourcesContent":[".zopim {\n   display: none;\n  }\n\nbody{\n   overflow-y: auto !important;\n   background-color: rgb(7, 90, 95);\n}\n  "],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
